/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import { useEffect, useRef } from 'react';

import ModernSettingsMenuItem from 'bundles/video-player/components/modernSettingsMenu/ModernSettingsMenuItem';

type MenuItem = {
  title: string;
  icon?: JSX.Element;
  action?: () => void;
  actionComponent?: JSX.Element;
  isSelected?: boolean;
  buttonWrapper?: boolean;
  role?: string;
};

type PropsFromCaller = {
  menuConfig: MenuItem[];
  visible: boolean;
};

const ModernSettingsMenuItemList = ({ menuConfig, visible }: PropsFromCaller) => {
  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Focus on the first focusable element only when the menu is visible and the menu element exists
    if (menuRef.current && visible) {
      const focusableMenuElements = menuRef.current.querySelectorAll(
        'a, area, button:not(.vjs-default-button):not(.vjs-close-button):not(.vjs-done-button), frame, iframe, input, object, textarea, [tabindex]:not([disabled]):not([tabindex="-1"]'
      );

      if (focusableMenuElements) {
        const tabbableElements = Array.from(focusableMenuElements) as HTMLElement[];
        tabbableElements[0]?.focus();
      }
    }
  }, [menuRef, visible]);

  return (
    <div role="menu" ref={menuRef}>
      {menuConfig.map((menuItem, idx) => {
        const isLastItem = idx === menuConfig.length - 1;
        return <ModernSettingsMenuItem key={menuItem.title} menuItem={menuItem} isLastItem={isLastItem} />;
      })}
    </div>
  );
};

export default ModernSettingsMenuItemList;
